// @core/api/endpoints/localization/bulk_export_translations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkExportTranslationsResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Bulk export translations
 * Exports translations for a locale and namespace in the specified format.
 */
export async function BulkExportTranslations(
  params?: {
  },
  options?: RequestOptions
): Promise<BulkExportTranslationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/translations/export`;
  const requestOptions = options;
  return client.get<BulkExportTranslationsResponse>(requestPath, { ...requestOptions, params });
}
